import React, { useState, useEffect } from 'react';
import { Box, Button, Divider, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { BreadCrumbsAndTitle } from '../../../components/generics/BreadCrumbsAndTitle';
import { hasPemissions } from '../../../commons/utils';
import { useDispatch } from 'react-redux';
import { getAreasRatingsByPagination } from '../../../store/ratings/thunks';
import { TableAreas } from './components/TableAreas';
import { FormAreaModal } from './components/FormAreaModal';
import { BannerInfoAreas } from './components/BannerInfoAreas';
import { alertInformativo } from '../../../commons/texts';
import { AlertsInformativos } from '../../../components/generics/AlertsInformativos';
import { mtDividerUpTable } from '../../../commons';

export const AreasCalificaciones = () => {
  const dispatch = useDispatch();
  const [openModalForm, setOpenModalForm] = useState(false);
  const [canCreate, setCanCreate] = useState<boolean>(false);

  useEffect(() => {
    checkPermissions();
  }, []);

  const checkPermissions = async () => {
    // Modify permission key based on your setup
    const create = await hasPemissions('modulo.configuracion', 'modulo.areas', 'create');
    if (create) setCanCreate(true);
  };

  const openModal = () => {
    setOpenModalForm(true);
  };

  const closeModal = () => {
    setOpenModalForm(false);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, margin: '0 auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <BreadCrumbsAndTitle
            title="Áreas de Calificación"
            mainModule="calificaciones"
            parent="Configuraciones"
            action="Áreas"
            icon="DashboardCustomize"
          />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            <AlertsInformativos
              type={'info'}
              title={'info'}
              content={alertInformativo.areasCalificaciones}
            />
          </Typography>
        </Box>

        {canCreate && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={openModal}
            sx={{
              borderRadius: 2,
              px: 3,
              py: 1,
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: '0px 4px 8px -4px rgba(105, 108, 255, 0.42)',
            }}
          >
            Crear Área
          </Button>
        )}
      </Box>

      <Divider sx={{ marginBottom: mtDividerUpTable }} />
      <TableAreas />

      <BannerInfoAreas />

      <FormAreaModal
        open={openModalForm}
        handleClose={closeModal}
        refreshData={() => {
          dispatch(getAreasRatingsByPagination(1));
        }}
      />
    </Box>
  );
};
